// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Banner----index-module---root---2bVb6","text":"src-components-Banner----index-module---text---2-Msl","button":"src-components-Banner----index-module---button---rdmfl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/index.module.css
// module id = 594
// module chunks = 114276838955818